var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0104 76.1824C76.5734 76.162 73.138 76.3358 69.7207 76.7032C68.4572 85.0895 67.7613 93.5516 67.6377 102.032C38.9764 101.157 30.0198 93.3459 30.0198 88.3052C29.5407 82.7854 37.7058 75.3909 62.3262 73.5787C63.3469 68.663 67.5127 49.3749 80.0104 49C92.5081 49.3749 96.674 68.663 97.6738 73.5787C122.294 75.3909 130.459 82.7854 129.98 88.3052C130.105 93.3459 121.044 101.157 92.4873 102.032C92.3637 93.5516 91.6678 85.0895 90.4043 76.7032C86.9524 76.3319 83.4821 76.158 80.0104 76.1824ZM61.2639 77.4739C60.093 84.319 59.397 91.2371 59.181 98.1783C45.1419 96.2204 40.976 92.3669 40.247 88.3052C40.5803 83.556 45.871 79.161 61.2639 77.4739ZM80.0104 73.0163C76.5319 73.0163 73.3242 73.0163 70.1373 73.2246C70.1373 71.6416 73.095 52.6035 80.0104 51.8745C86.9258 52.6035 89.8211 71.6416 89.8836 73.2246C86.6967 73.058 83.4889 72.9955 80.0104 73.0163ZM98.7569 77.4739C99.9176 84.3204 100.613 91.2377 100.84 98.1783C114.879 96.2204 119.045 92.3669 119.774 88.3052C119.441 83.556 114.15 79.161 98.7569 77.4739Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -60.5139,
    y1: 220.923,
    x2: 137.758,
    y2: 22.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 79.9554,
    y1: 102.036,
    x2: 79.9554,
    y2: 49.0425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoInner);
export default __webpack_public_path__ + "static/media/picto_inner.f5a105f835b0fd6259c92901ed338364.svg";
export { ForwardRef as ReactComponent };